import {
    GetL1AssessmentsResponse,
    GetMigrationPlanTotalsResponse,
    GetInstancesResponse,
    GetFastshiftCustomerDomainsResponse,
    GetFastshiftCustomerDomainResponseData,
    GetCustomerDomainEngagementResponseData,
    CustomerDomainEngagementExpectedError,
    FastshiftUserDetailsExpectedError,
    GetFastshiftUserResponse,
    GetFastshiftSupportRequestsResponseData,
    FastshiftTableControlsPayload,
    GetFastshiftPortalUserConsentResponse,
    GetFastshiftTopSupportRequestsResponseData
} from "@/libraries/bxp-web-stargate-client/src";

import { TABLE_IDS } from "./constants";

type BaseThunk = {
    pending: boolean;
    error: string | null;
};

export type Org = {
    id: string;
    isAdmin: boolean;
    name: string;
};

export type Orgs = BaseThunk & {
    data: Org[];
};

export type MigrationPlanTotals = BaseThunk & {
    data: GetMigrationPlanTotalsResponse;
};

export type L1Assessments = BaseThunk & {
    data: GetL1AssessmentsResponse;
};

export type InstancesRequest = BaseThunk & {
    data: { instances: GetInstancesResponse["instances"]; totalCount: number };
};

export type FastshiftCustomerDomainsState = BaseThunk & {
    data: GetFastshiftCustomerDomainsResponse;
};

export type CustomerDomainDetails = BaseThunk & {
    data: GetFastshiftCustomerDomainResponseData | null;
};

export type CustomerDomainOrg = NonNullable<
    CustomerDomainDetails["data"]
>["orgsWithAdminRole"][number];

export type CustomerDomainEngagement = BaseThunk & {
    data: GetCustomerDomainEngagementResponseData | null;
};

export {
    CustomerDomainEngagementExpectedError,
    FastshiftUserDetailsExpectedError
};

export const FastshiftApiAbortError = "AbortError";

export type UserDetails = BaseThunk & {
    data: GetFastshiftUserResponse["data"] | null;
};

export type SupportRequests = BaseThunk & {
    data: GetFastshiftSupportRequestsResponseData | null;
    lastFetchParams?: {
        customerDomainId: string;
        queryParams: {
            orgId?: string;
            permissionLevel?: string;
        };
    };
};

export type TopSupportRequests = BaseThunk & {
    data: GetFastshiftTopSupportRequestsResponseData | null;
    lastFetchParams?: {
        customerDomainId: string;
        queryParams: {
            orgId?: string;
            permissionLevel?: string;
        };
    };
};

export type TableId = (typeof TABLE_IDS)[keyof typeof TABLE_IDS];

// Extend BE payload with FE-specific filters
export type FastshiftPortalTableControls = FastshiftTableControlsPayload & {
    filters: Record<string, string | null>;
};

export type PageStateCache = Record<TableId, FastshiftPortalTableControls>;

export type PortalUserConsent = BaseThunk & {
    data: GetFastshiftPortalUserConsentResponse["data"]["consent"] | null;
};
